import alertify from 'alertifyjs'
import moment from 'moment'

const Helper = {}

Helper.install = function (Vue, options) {
  Vue.prototype.$helper = {
    displayPrice (val, currency) {
      let a = Number(val)
      return a.toString().replace('.', ',') + ' ' + currency
    },
    emptyObject (obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false
        }
      }
      return JSON.stringify(obj) === JSON.stringify({})
    },
    stdErrors (resp) {
      if (typeof resp.body.errors !== 'undefined' && Object.getOwnPropertyNames(resp.body.errors).length > 0) {
        for (let e in resp.body.errors) {
          alertify.notify(resp.body.errors[e], 'error', 3)
        }
      }
    }
  }
  Vue.prototype.$alertify = alertify
  Vue.prototype.$moment = moment
}

export default Helper



// WEBPACK FOOTER //
// ./src/plugins/helper.js